import { API_URL } from "../Config";

export const getRedirectURL = async () => {
  const response = await fetch(`${API_URL}/auth/oidc/url`);
  const data = await response.json();
  if (data.token === "noauth") {
    // dummy auth for development
    localStorage.setItem("token", data.token);
    return "/";
  }
  return data.url;
};

export const login = async code => {
  const response = await fetch(`${API_URL}/auth/oidc/callback?code=${code}`);
  const data = await response.json();

  // store JWT token in local storage
  if (data.token) {
    localStorage.setItem("token", data.token);
    localStorage.setItem("name", data.name);
    localStorage.setItem("email", data.email);
    localStorage.setItem("username", data.username);
    localStorage.setItem("isSATUser", data.isSATUser);
  }

  if (data.url) {
    return data.url;
  }

  if (!data.isSATUser) {
    return "/myperformancescheme";
  }

  return "/";
};

export const isLoggedIn = () => localStorage.getItem("token") !== null;
